var Alert            = require("app/ui/Alert"),
    ButtonMessage    = require("app/ui/ButtonMessage"),
    ControlGroup     = require("app/ui/ControlGroup"),
    IconButton       = require("app/ui/IconButton"),
    Input            = require("app/ui/Input"),
    Signals          = require("enyo/Signals"),
    SimplePageView   = require("app/AppLayout/SimplePageView"),
    VimeoBackground  = require("app/ui/VimeoBackground"),
    deepEqual        = require("fast-deep-equal"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    isIosApp         = require("app/utils/isIosApp"),
    kind             = require("enyo/kind"),
    quickMacroize    = require("enyo/macroize").quickMacroize,
    utils            = require("enyo/utils"),
    videoBackgrounds = require("app/theme/VideoBackgrounds");

require("./PageView.less");
require("app/ui/ControlGroup.less");
require("app/theme/Alert--error.less");
require("app/theme/ControlGroup--default.less");
require("app/theme/ControlLabel--default.less");
require("app/theme/Input--default.less");
require("app/theme/IconButton--cta.less");

module.exports = kind(/** @lends  app.ForgotPasswordPage.PageView.prototype */ {

    /**
     * @private
     */
    name: "app.ForgotPasswordPage.PageView",

    /**
     * @private
     */
    kind: SimplePageView,

    /**
     * @private
     */
    classes: "app-forgot-password-page-page-view",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @name     rawBackgroundImageSrc
     * @type     {string}
     * @memberof app.ui.PageBackgroundSupport
     * @public
     */
    rawBackgroundImageSrc: require("app/theme/assets/page-background-color.png"),

    /**
     * Whether the form is currently submitting.
     *
     * @type     {boolean}
     * @default  'false'
     * @public
     */
    isSubmitting: false,

    /**
     * @private
     */
    components: [{
        kind:    Signals,
        onkeyup: "handleKeyUp"
    }, {
        name:       "forgotPasswordForm",
        classes:    "app-forgot-password-page-page-view__forgot-password-form",
        tag:        "form",
        attributes: {
            onsubmit: "return false;"
        },
        canGenerate: false,
        components:  [{
            name:    "title",
            tag:     "h1",
            classes: "app-forgot-password-page-page-view__title"
        }, {
            name:    "instructions",
            tag:     "p",
            classes: "app-forgot-password-page-page-view__instructions"
        }, {
            name:      "formErrorAlert",
            kind:      Alert,
            classes:   "app-forgot-password-page-page-view__form-error-alert",
            theme:     "error",
            allowHtml: true
        }, {
            kind:       ControlGroup,
            classes:    "app-forgot-password-page-page-view__forgot-password-form__email",
            components: [{
                name:       "emailInput",
                kind:       Input,
                type:       "email",
                attributes: {
                    name:             "email",
                    autocomplete:     "username",
                    required:         "required",
                    "data-hj-masked": "",
                    pattern:          "^([^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+|\\x22([^\\x0d\\x22\\x5c\\x80-\\xff]|\\x5c[\\x00-\\x7f])*\\x22)(\\x2e([^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+|\\x22([^\\x0d\\x22\\x5c\\x80-\\xff]|\\x5c[\\x00-\\x7f])*\\x22))*\\x40([^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+|\\x5b([^\\x0d\\x5b-\\x5d\\x80-\\xff]|\\x5c[\\x00-\\x7f])*\\x5d)(\\x2e([^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+|\\x5b([^\\x0d\\x5b-\\x5d\\x80-\\xff]|\\x5c[\\x00-\\x7f])*\\x5d))*(\\.\\w{2,})+$"
                },
                theme:  "default",
                onblur: "onFormControlBlur"
            }, {
                name:    "emailInstructions",
                classes: "app-ui-control-instructions"
            }]
        }, {
            kind:       ControlGroup,
            classes:    "app-forgot-password-page-page-view__forgot-password-form__actions",
            components: [{
                name:    "submitButton",
                kind:    IconButton,
                classes: "app-forgot-password-page-page-view__forgot-password-form__forgot-password-button",
                tag:     "button",
                theme:   "cta",
                icon:    icons["app.ForgotPasswordPage.PageView.submitButton"],
                ontap:   "onSubmitButtonClick"
            }]
        }]
    }, {
        name:          "formSuccessMessage",
        kind:          ButtonMessage,
        classes:       "app-forgot-password-page-page-view__form-success-message",
        buttonCommand: "onSuccessMessageButtonTap",
        canGenerate:   false
    }],

    /**
     * @private
     */
    handlers: {
        onSubmitButtonClick:       "onSubmitButtonClick",
        onSuccessMessageButtonTap: "onSuccessMessageButtonTap"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.createVideoBackground();
            sup.apply(this, arguments);
            this.$.formSuccessMessage.$.button.set("theme", "neutral");
            this.$.formSuccessMessage.$.button.set("icon", icons["app.ForgotPasswordPage.PageView.successButton"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    createVideoBackground: function() {
        if (!isIosApp && get(videoBackgrounds, "ForgotPasswordPage.type", null) === "vimeo") {
            this.createComponents([{
                name:        "videoBackground",
                kind:        VimeoBackground,
                videoId:     get(videoBackgrounds, "ForgotPasswordPage.videoId", null),
                aspectRatio: get(videoBackgrounds, "ForgotPasswordPage.aspectRatio", null)
            }]);
        }
    },

    /**
     * @public
     */
    update: function() {
        var i18nService         = this.app.$.i18nService,
            state               = this.state || {},
            $submitButton       = this.$.submitButton,
            $formErrorAlert     = this.$.formErrorAlert,
            $emailInput         = this.$.emailInput,
            $formSuccessMessage = this.$.formSuccessMessage,
            $form               = this.$.forgotPasswordForm,
            redirectPath;

        // If form is in not in success state, we show the form and not the
        // success message.
        if (!state.formSuccess) {
            this.$.title.set("content", i18nService.getString("app.ForgotPasswordPage.title"));
            this.$.instructions.set("content", i18nService.getString("app.ForgotPasswordPage.instructions"));

            $emailInput.setAttribute("placeholder", i18nService.getString("app.ForgotPasswordPage.Email.label"));
            $emailInput.set("tooltip", i18nService.getString("app.ForgotPasswordPage.Email.instructions"));
            this.$.emailInstructions.set("content", i18nService.getString("app.ForgotPasswordPage.Email.instructions"));

            $submitButton.set("caption", i18nService.getString("app.ForgotPasswordPage.SubmitButton.caption"));
            $submitButton.set("tooltip", i18nService.getString("app.ForgotPasswordPage.SubmitButton.tooltip"));

            // Error state
            switch (state.formError) {
                case "pending_user":
                    $formErrorAlert.set("content", i18nService.getString("app.ForgotPasswordPage.pendingUser"));
                    break;
                case "invalid_user":
                    $formErrorAlert.set("content", i18nService.getString("app.ForgotPasswordPage.invalidCredentials"));
                    break;
                case "unknown_error":
                default:
                    $formErrorAlert.set("content", i18nService.getString("app.ForgotPasswordPage.unknownError"));
                    break;
            }
            state.formError ? $formErrorAlert.show() : $formErrorAlert.hide();

            if ($formSuccessMessage.get("canGenerate")) {
                $formSuccessMessage.removeNodeFromDom();
                $formSuccessMessage.teardownRender();
                $formSuccessMessage.set("canGenerate", false);
            }

            if (!$form.get("canGenerate")) {
                $form.set("canGenerate", true);
                $form.render();
            }
        }

        // If form is in success state, we show the success message and not the
        // form.
        else {
            $formSuccessMessage.$.title.set("content", i18nService.getString("app.ForgotPasswordPage.SuccessMessage.title"));
            $formSuccessMessage.$.body.set("content", i18nService.getString("app.ForgotPasswordPage.SuccessMessage.body"));
            $formSuccessMessage.$.button.set("caption", i18nService.getString("app.ForgotPasswordPage.SuccessMessage.Button.caption"));
            $formSuccessMessage.$.button.set("tooltip", i18nService.getString("app.ForgotPasswordPage.SuccessMessage.Button.tooltip"));

            redirectPath = state.redirectPath || "";
            redirectPath = "/" + redirectPath.replace(/^\/+/, "");
            redirectPath = encodeURIComponent(redirectPath);

            $formSuccessMessage.$.button.set("href", quickMacroize("/{$language}/login/{$redirectPath}", {
                language:     i18nService.get("language"),
                redirectPath: redirectPath
            }));

            if ($form.get("canGenerate")) {
                $form.removeNodeFromDom();
                $form.teardownRender();
                $form.set("canGenerate", false);
            }

            if (!$formSuccessMessage.get("canGenerate")) {
                $formSuccessMessage.set("canGenerate", true);
                $formSuccessMessage.render();
            }
        }
    },

    /**
     * @method
     * @private
     */
    absoluteShowingChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.absoluteShowing
                && !this.app.$.continueSignUpPopup.get("showing")
                && !this.app.$.privacyService.get("cmpUiShown")
            ) {
                this.$.emailInput.focus();
            }
        };
    }),

    /**
     * Instruct the router to navigate to the new location
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The tap event
     * @returns  {boolean}       Stop propagation
     * @private
     */
    onSuccessMessageButtonTap: function(sender, event) {
        this.app.$.router.navigate(event.originator.get("href"));

        return true;
    },

    // Submit form
    // --------------------------------
    // The methods below are used to handle form submission.
    // --------------------------------

    /**
     * Pressing `enter` should submit the form if focus element is a child of
     * the form element.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @private
     */
    handleKeyUp: function(sender, event) {
        var $form    = this.$.forgotPasswordForm,
            formNode = $form.hasNode();

        // Do nothing if the event was already processed
        if (event.defaultPrevented) {
            return;
        }

        // We only react to the `Enter` key.
        if (event.key !== "Enter" && event.keyCode !== 13) {
            return;
        }

        // The active element on the page is not part of the login form.
        if (!formNode === document.activeElement
            && !formNode.contains(document.activeElement)) {
            return;
        }

        // Time to submit the form
        event.preventDefault();
        this.submit();
    },

    /**
     * Prevent default submit behavior and trigger our own submission
     * implementation of the password reset form.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    onSubmitButtonClick: function(sender, event) {
        event && event.preventDefault();
        this.submit();
    },

    /**
     * Validate the form and submit a request for a new password as needed.
     *
     * @private
     */
    submit: function() {
        var authService = this.app.$.authService,
            form        = this.$.forgotPasswordForm,
            formNode    = form ? form.hasNode() : null,
            autofocusNode;

        // Nothing to do right now.
        if (!formNode || this.isSubmitting) {
            return;
        }

        // If form isn't valid, focus first field with error and leave it at
        // that.
        if (!this.validateForm()
            && !this.app.$.continueSignUpPopup.get("showing")
            && !this.app.$.privacyService.get("cmpUiShown")
        ) {
            autofocusNode = formNode.querySelector(".invalid");
            autofocusNode && autofocusNode.focus();

            return;
        }

        // Submit form
        this.set("isSubmitting", true);
        authService
            .requestPasswordReset(this.$.emailInput.value)
            .then(this.bindSafely(function(response) {
                switch (response.status) {
                    case "ok":
                        this.onSuccess();
                        break;
                    case "error":
                    default:
                        this.onFail(response.type || "unknown_error");
                        break;
                }
                this.set("isSubmitting", false);
            }));
    },

    /**
     * Validate form field on blur.
     *
     * @param  {enyo.Control}  sender  The control that just blurred.
     * @protected
     */
    onFormControlBlur: function(sender) {
        this.validateField(sender);
    },

    /**
     * Validate the entire form.
     *
     * @returns  {boolean}  Whether the form is valid.
     * @protected
     */
    validateForm: function() {
        var controlNames = ["emailInput"],
            isValid      = true;

        controlNames.forEach(this.bindSafely(function(name) {
            var control = this.$[name];

            if (!control || !this.validateField(control)) {
                isValid = false;
            }
        }));

        return isValid;
    },

    /**
     * Validates the field, returns whether it is valid.
     *
     * @param  {enyo.Control}  control  The form control
     * @return {boolean}       `true` if valid, `false` otherwise
     */
    validateField: function(control) {
        var node = control.hasNode();

        // Field is valid
        if (node && (
            node.disabled
            || node.type === "submit"
            || node.validity.valid)) {
            control.removeClass("invalid");

            return true;
        }

        // Field is invalid
        else {
            control.addClass("invalid");

            return false;
        }
    },

    /**
     * Show a scrim and loading graphic when form is submitting.
     *
     * @param  {boolean}  wasSubmitting  Whether the form was submitting before.
     * @private
     */
    isSubmittingChanged: function(wasSubmitting) {
        var isSubmitting = this.isSubmitting,
            appView      = this.app.view;

        if (!wasSubmitting && isSubmitting) {
            appView.requestShowLoadingGraphic();
        }

        else if (wasSubmitting && !isSubmitting) {
            appView.requestHideLoadingGraphic();
        }
    },

    /**
     * @private
     */
    onSuccess: function() {
        var state = utils.clone(this.state);

        delete state.formError;
        state.formSuccess = true;

        // Update state only if it actually changed
        if (!deepEqual(this.state, state)) {
            this.set("state", state);
        }
    },

    /**
     * @param  {string}  error  The error
     * @private
     */
    onFail: function(error) {
        var state = utils.clone(this.state);

        delete state.formSuccess;
        state.formError = error;

        // Update state only if it actually changed
        if (!deepEqual(this.state, state)) {
            this.set("state", state);
        }
    },

    /**
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            // Needed to hide the scrim and loading graphic again.
            if (this.isSubmitting) {
                this.set("isSubmitting", false);
            }
            sup.apply(this, arguments);
        };
    })

});
